export const categories = [
  {
    slug: "renwu-fenxi",
    name: "人物分析",
    description: "深度剖析「好色小姨」角色的性格特征、行为动机与人物弧光，解读这一经典设定的文学价值与戏剧张力。",
    icon: "ri-user-search-line",
    color: "accent",
    articleCount: 3,
  },
  {
    slug: "gushi-heji",
    name: "故事合集",
    description: "精选都市言情小说中与「好色小姨」相关的经典情节片段，带你重温那些令人心跳加速的精彩瞬间。",
    icon: "ri-book-open-line",
    color: "primary",
    articleCount: 3,
  },
  {
    slug: "chuangzuo-linggan",
    name: "创作灵感",
    description: "为小说创作者提供「好色小姨」类型角色的塑造技巧、情节设计思路与创新突破点，激发你的创作灵感。",
    icon: "ri-lightbulb-line",
    color: "secondary",
    articleCount: 2,
  },
  {
    slug: "qinggan-luoji",
    name: "情感逻辑",
    description: "从心理学和情感关系角度，解析「好色小姨」角色行为背后的情感逻辑、内心矛盾与人际关系网络。",
    icon: "ri-heart-pulse-line",
    color: "accent",
    articleCount: 2,
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});